import textStyles from 'config/branding/textStyles';
import styleObjectToProps, { StyleProps, Styles } from '@activebrands/core-web/utils/style-object-to-props';

const responsiveTextStyles = (fontKeys: Styles): StyleProps => styleObjectToProps(fontKeys, textStyles);

export default responsiveTextStyles;
